module.exports = {"id":"189207","name":"Jimmy Durmaz","rating":"75","photo":"./data/images/photos/3/189207.png","club":{"name":"Toulouse FC","logo":"./data/images/clubs/ToulouseFC.png"},"positions":["MG","MOC","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JimmyDurmaz0.json
// module id = 2021
// module chunks = 0